import React from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';
import breohiologo from "../../../Assets/breohiologo.svg";
import hqlogo from "../../../Assets/hqlogo.svg";
const LocationTableBRE = ({ locationTableData }) => {
    return (
        <TableContainer component={Paper} style={{ pageBreakInside: "avoid" }}>
            <Table style={{ pageBreakInside: "avoid" }}>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: '0%', background: '#FAF8F8' }}></TableCell>
                        <TableCell style={{ width: '0%', background: '#FAF8F8' }}></TableCell>
                        <TableCell style={{ width: '20%', background: '#FAF8F8' }}><p className='bre-table-th-address'> Address  </p></TableCell>
                        <TableCell style={{ width: '10%', background: '#FAF8F8' }}><p className='bre-table-th'>City </p></TableCell>
                        <TableCell style={{ width: '10%', background: '#FAF8F8' }}><p className='bre-table-th'>State </p></TableCell>
                        <TableCell style={{ width: '10%', background: '#FAF8F8' }}><p className='bre-table-th'>Zip </p></TableCell>
                        <TableCell style={{ width: '10%', background: '#FAF8F8' }}><p className='bre-table-th'>County </p></TableCell>
                        <TableCell style={{ width: '10%', background: '#FAF8F8' }}><p className='bre-table-th'>Country </p></TableCell>
                        <TableCell style={{ width: '15%', background: '#FAF8F8' }}><p className='bre-table-th'>Job Openings </p></TableCell>
                        <TableCell style={{ width: '20%', background: '#FAF8F8' }}><p className='bre-table-th'>Landowner </p></TableCell>
                    </TableRow>
                </TableHead>
                {locationTableData && Object.keys(locationTableData).length > 0 ? (
                    <TableBody style={{ pageBreakInside: "avoid" }}>
                        {(Array.isArray(locationTableData) ? locationTableData : [locationTableData]).map((item) => (
                            <TableRow key={item.id} style={{ pageBreakInside: "avoid" }}>
                                <TableCell style={{ backgroundColor: item?.is_hq === true ? '#00A3E01A' : 'transparent' }}>{item?.is_hq === true ? <img src={hqlogo} alt="" /> : ""}</TableCell>
                                <TableCell style={{ backgroundColor: item?.is_hq === true ? '#00A3E01A' : 'transparent' }}>{(item?.state === "oh" || item?.state === " oh" || item?.state === "ohio" ) ? <img src={breohiologo} alt="" /> : ""}</TableCell>
                                <TableCell style={{ backgroundColor: item?.is_hq === true ? '#00A3E01A' : 'transparent' }}><p className='bre-table-tr-badge'>
                                    {/* {item?.is_hq === true ? <img src={hqlogo} alt="" /> : ""} */}
                                    {/* {(item?.state === "oh" || item?.state === " oh") ? <img src={breohiologo} alt="" /> : ""} */}
                                    {item?.address ?? "-"}</p></TableCell>
                                <TableCell style={{ backgroundColor: item?.is_hq === true ? '#00A3E01A' : 'transparent' }}
                                ><p className='bre-table-tr'>{item?.city ?? "-"}</p></TableCell>
                                <TableCell style={{ backgroundColor: item?.is_hq === true ? '#00A3E01A' : 'transparent' }}
                                ><p className='bre-table-tr'>{item?.state ?? "-"}</p></TableCell>
                                <TableCell style={{ backgroundColor: item?.is_hq === true ? '#00A3E01A' : 'transparent' }}
                                ><p className='bre-table-tr'>{item?.zip_code ?? "-"}</p></TableCell>
                                <TableCell style={{ backgroundColor: item?.is_hq === true ? '#00A3E01A' : 'transparent' }}
                                ><p className='bre-table-tr'>{item?.county ?? "-"}</p></TableCell>
                                <TableCell style={{ backgroundColor: item?.is_hq === true ? '#00A3E01A' : 'transparent' }}
                                ><p className='bre-table-tr'>{item?.country ?? "-"}</p></TableCell>
                                <TableCell style={{ backgroundColor: item?.is_hq === true ? '#00A3E01A' : 'transparent' }}
                                ><p className='bre-table-tr'>{item?.job_count != null ? item?.job_count : "-"}</p></TableCell>
                                <TableCell style={{ backgroundColor: item?.is_hq === true ? '#00A3E01A' : 'transparent' }}
                                ><p className='bre-table-tr'>{item?.landowner_name ?? "-"}</p></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                ) : (<TableBody>
                    <TableRow>
                        <TableCell colSpan={8} align="center">
                            No Data Available
                        </TableCell>
                    </TableRow>
                </TableBody>)}


            </Table>
        </TableContainer>
    )
}
export default LocationTableBRE
